/** Lightweight localStorage cache for Wholesalers page data. */

export const WH_DIR_CACHE_KEY = "wholesalers_directory_cache_v1";
export const WH_ORDERS_CACHE_KEY = "wholesalers_orders_cache_v1";

export function readCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeCache(key, payload) {
  try {
    localStorage.setItem(
      key,
      JSON.stringify({ ...payload, cachedAt: Date.now() }),
    );
  } catch {
    // quota / private mode — ignore
  }
}

export function clearCache(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
